export const SET_SEARCH_CLIENTS = 'SET_SEARCH_CLIENTS';
export const SET_SEARCH_INVOICES = 'SET_SEARCH_INVOICES';
export const CLEAN_REDUCER = 'CLEAN_REDUCER';
export const CLEAR_SESSION = 'CLEAR_SESSION';
